<!--================================
        START HERO AREA
=================================-->
<section class="medshorts-container">
  <section class="medshorts-hero-section-container font-white">
    <div id="medshorts-hero-text">
      <h1>The Online Marketplace for Drugs in Surplus & Shortage</h1>
      <h3>
        Helping the pharmaceutical<br />
        supply chain save money<br />
        and improve access
      </h3>
    </div>
    <section id="medshorts-hero-img">
      <img
        id="laptop-image"
        src="/assets/img/static-pages/medshorts/MS_Header_Laptop Graphic-01.png"
        alt="laptop-img"
      />
    </section>
  </section>
  <section class="roadmap-section-main-grid">
    <section class="roadmap-section-flex-container">
      <section class="where-it-starts-section">
        <img
          id="manufacturer-image"
          src="/assets/img/static-pages/medshorts/MS_Isometric Illustrations_1-01.png"
          alt="Manufacturer Graphic Image"
        />
        <section class="where-it-starts-full-copy">
          <h2 class="subsection-header subtitle-font">Where it starts</h2>
          <ul class="subsection-copy body-font">
            <li>
              <p>
                Pharma Manufacturers list excess inventory<br />
                to a community of pharmacies
              </p>
            </li>
            <li>
              <p>
                The shelf-life pricing model helps mitigate<br />
                short-dated waste
              </p>
            </li>
          </ul>
        </section>
      </section>
      <section class="how-pharmacies-benifit-section">
        <section class="how-pharmacies-benifit-full-copy">
          <h2 class="subsection-header subtitle-font">
            How pharmacies benefit
          </h2>
          <ul class="subsection-copy body-font">
            <li>
              <p>
                Access is open to all pharmacies, with no cost<br />
                to enroll or purchasing obligations
              </p>
            </li>
            <li>
              <p>
                Single login to an open marketplace of surplus<br />
                stock available for purchase or bid <b>directly</b> with<br />
                each manufacturer
              </p>
            </li>
            <li>
              <p>
                User friendly, web based account that generates<br />
                incremental cost savings, promotes sustainability<br />
                and provides pharmacies with a drug shortage resource
              </p>
            </li>
          </ul>
        </section>
        <img
          id="manufacturer-image"
          src="/assets/img/static-pages/medshorts/MS_Isometric Illustrations_2-01.png"
          alt="Pharmacy Graphic Image"
        />
      </section>
      <section class="what-we-do-section">
        <img
          id="manufacturer-image"
          src="/assets/img/static-pages/medshorts/MS_Isometric Illustrations_3-01.png"
          alt="Online Shopping Graphic Image"
        />
        <section class="what-we-do-full-copy">
          <h2 class="subsection-header subtitle-font">What we do</h2>
          <ul class="subsection-copy body-font">
            <li>
              <p>
                MedShorts connects pharmacies and drug manufacturers<br />
                through an online marketplace for hassle-free drug<br />
                procurement, with services including:
              </p>
            </li>
            <li>
              <p>Live customer care and dedicated account support</p>
            </li>
            <li>
              <p>Consolidated invoicing and payment processing</p>
            </li>
            <li>
              <p>Shipment tracking</p>
            </li>
          </ul>
        </section>
      </section>
      <section class="streamlined-access-section">
        <section class="streamline-access-full-copy">
          <h2 class="subsection-header subtitle-font">Streamlined access</h2>
          <ul class="subsection-copy body-font">
            <li>
              <p>
                Single login to over 65 manufacturers<br />
                easy ordering and drug access
              </p>
            </li>
            <li>
              <p>
                Real-time ASHP link to notify<br />
                pharmacies with drug shortage updates
              </p>
            </li>
          </ul>
        </section>
        <img
          id="manufacturer-image"
          src="/assets/img/static-pages/medshorts/MS_Isometric Illustrations_4-01.png"
          alt="retail Pharmacy Graphic Image"
        />
      </section>
      <section class="waste-reduction-section">
        <h3 class="subsection-header waste-reduction-header">
          Pharmaceutical waste reduction
        </h3>
        <h3 class="waste-reduction-info font-white">9,327,881 Units</h3>
        <p class="subsection-copy waste-reduction-copy">
          Spared from Incineration
        </p>
      </section>
    </section>
  </section>
  <button
    id="how-pharmacies-benifit-btn"
    (click)="navigateToSubPages('pharmacy')"
  >
    Pharmacy Enrollment
  </button>
  <button id="where-it-starts-btn" (click)="navigateToSubPages('manufacturer')">
    Manufacturer Enrollment
  </button>
</section>
